(() => {
    function applyParallax(element) {
        const [start, end] = element.dataset.parallax.split(",").map(Number);
        const distance = end - start;

        let elementTop = 0;
        let currentElement = element;
          while (currentElement) {
            elementTop += currentElement.offsetTop || 0;
            currentElement = currentElement.offsetParent;
        }

        const viewportHeight = window.innerHeight;
        const unitScroll = distance / (viewportHeight + element.offsetHeight);

        const parallaxEffect = () => {
            const scrolled = document.documentElement.scrollTop;
            const relativeDistance = scrolled + viewportHeight - elementTop;
            const translation = unitScroll * relativeDistance + start;
            const progress = (translation - start) / (end - start);

            const value = element.dataset.parallaxMax ? Math.min(translation, +element.dataset.parallaxMax) : translation;

            element.style.transform = `translate3d(0, ${value}px, 0)`;

            element.dataset.visibleAt && element.classList.toggle("visible", progress >= element.dataset.visibleAt);
        };

        const handleScroll = () => requestAnimationFrame(parallaxEffect);
        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }

    const parallaxObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target._cleanParallax = applyParallax(entry.target);
            } else if (entry.target._cleanParallax) {
                entry.target._cleanParallax();
                delete entry.target._cleanParallax;
            }
        });
    }, { threshold: 0 });

    document.querySelectorAll("[data-parallax]").forEach(element => {
        parallaxObserver.observe(element);
    });
})();
